import { Layout } from "@/components/layout/Layout";
import { getStrapiCollection, getStrapiEntity } from "@/utils/strapi";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { createQueryCategoryPage } from "@/strapiQuery/categoryPage";
import {
  formatFirstCategoryPage,
  StrapiCategoryPage,
} from "@/utils/formatCategoryPage";
import { VehicleType } from "@/components/common/searchBlock/children/vehicleTypeSelection/VehicleTypeSelection";
import { page404 } from "@/const/page404";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";

type GetStaticPropsParams = LoadI18nMessagesProps & {
  params: { slug: string };
};

export const getStaticProps = async (ctx: GetStaticPropsParams) => {
  const layout = await getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );

  const intlMessages = loadIntlMessages(ctx);

  const strapiCategoryPages = await getStrapiCollection<StrapiCategoryPage>(
    "category-pages",
    createQueryCategoryPage(ctx.params.slug, VehicleType.TRUCK)
  );
  if (strapiCategoryPages.length === 0) {
    return page404;
  }
  const categoryPageContent = formatFirstCategoryPage(strapiCategoryPages);

  return {
    props: {
      layout,
      reviewsConst,
      intlMessages,
      slug: ctx.params.slug,
      vehicleType: VehicleType.TRUCK,
      ...categoryPageContent,
    },
    revalidate: 10,
  };
};

export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export { CategoryPage as default } from "@/components/pages/vehicle/categoryPage/CategoryPage";
